<template>
    <div v-if="props.question.showQuestionIf && showQuestionIf(props.question)" class="mt-3 mb-2 ms-3">
        <div v-if="props.question.text != null">{{ props.question.text[participant.language] }}</div>
        <input 
            class="form-control" 
            type="text"
            :name="props.question.variable"
            v-model="response[props.question.variable]"
            @input="debounceInput"
        >
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'
    import debounce from "lodash/debounce"

    const { saveResponse, showQuestionIf } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])

    const debounceInput = debounce(() => {
      saveResponse()
    }, 1000)
</script>